// extracted by css-extract-rspack-plugin
export default {"panel":"product-detail-fragment__ServiceConsultant_panel__FafLb"};